<template>
  <iFormItem
    :label-for="name"
    :label-width="labelWidth"

    :required="isRequired"

    :error="firstError"
    show-message
  >
    <span
      v-if="label"
      slot="label"
      :class="$style.label"
      v-text="$label"
    />
    <slot>
      <component
        v-validate="validate"
        :is="typeComponents[type]"
        v-model="$form.data[prop]"
        :name="name"
        :placeholder="$placeholder"
        :readonly="isReadonly"
        :data-vv-as="$label"
        v-bind="typeOptions"
      />
    </slot>

  </iFormItem>
</template>

<style lang="scss" module>
.label {
  display: inline-block;
  &::first-letter {
    text-transform: capitalize;
  }
}
</style>

<script>

import * as InputComponents from './inputs';

export default {
  name: 'GdlFormItem',
  inject: ['$form', '$validator'],
  props: {
    name: { type: String, default: undefined },
    prop: { type: String, default: undefined },
    default: { type: [String, Number, Boolean, Array, Object], default: undefined },

    type: { type: String, validator: _ => ['input', 'textarea', 'select', 'switch', 'custom'].includes(_), default: 'custom' },
    typeOptions: { type: Object, default: () => ({}) },

    label: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },

    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },

    required: { type: Boolean, default: undefined },
    validate: { type: [String, Object], default: undefined },

    labelWidth: { type: Number, default: undefined },
  },
  data() {
    return {
      typeComponents: {
        input: InputComponents.gdlInput,
        textarea: InputComponents.gdlTextarea,
        select: InputComponents.gdlSelect,
        switch: InputComponents.gdlSwitch,
      },
    };
  },
  computed: {
    $label() {
      const { label } = this;
      return label && this.$t(this.label);
    },
    $placeholder() {
      const { placeholder, $label } = this;
      return placeholder && this.$te(placeholder) ?
        this.$t(placeholder, { field: $label }) :
        this.$t('forms.placeholder', { field: $label });
    },
    field() {
      return this.fields[this.name];
    },
    isRequired() {
      const { isReadonly, required, field = {} } = this;
      if (isReadonly) return false;
      if (required !== undefined) return required;
      return field.required;
    },
    isReadonly() {
      const { readonly, $form = {} } = this;
      const { readonly: formReadonly } = $form;
      return readonly || formReadonly;
    },
    firstError() {
      if (!this.name) return '';
      if (this.errors.has(this.name)) { return this.errors.first(this.name); }
      return '';
    },
  },
  created() {
    const { $form, name } = this;
    if (!$form || !name) return;

    $form.$registerField(name, this);
    this.$once('hook:beforeDestroy', () => {
      $form.$unregisterField(name);
    });
  },
};
</script>
